/* Won't Miss Garage - scroll reveals and motion staging.
   Respects Theme settings > Effects > Animations and prefers-reduced-motion. */
(function () {
  'use strict';
  var level = document.body.getAttribute('data-wmg-anim') || 'full';
  if (level === 'off') return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var selectors = [
    '.wmg-main > .shopify-section',
    '.wmg-tiles > *',
    '.wmg-grid > *',
    '.wmg-steps__item',
    '.wmg-faq__item',
    '.wmg-socials__embed > *',
    '.wmg-prop__card'
  ];
  var seen = [];
  selectors.forEach(function (sel) {
    Array.prototype.forEach.call(document.querySelectorAll(sel), function (el) {
      if (seen.indexOf(el) === -1) seen.push(el);
    });
  });

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });

  seen.forEach(function (el) {
    el.classList.add('wmg-reveal');
    var parent = el.parentElement;
    if (parent) {
      var i = Array.prototype.indexOf.call(parent.children, el);
      el.style.transitionDelay = Math.min(i % 8, 6) * 70 + 'ms';
    }
    io.observe(el);
  });
})();
